import { useEntity, useRelatedEntities } from '@backstage/plugin-catalog-react';
import { RELATION_HAS_PART } from '@backstage/catalog-model';
import { usedByEntitiesList, usingEntitiesList } from './common';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import useAsync from 'react-use/lib/useAsync';
import { SystemRelationshipsWrapperCard } from './SystemRelationshipsWrapperCard';

/**
 * Example of a system - Authorization
 * http://localhost:3000/catalog/default/system/authorization
 */
export const SystemRelationshipsCard = () => {
  const { entity } = useEntity();
  const { entities = [], loading } = useRelatedEntities(entity, {
    type: RELATION_HAS_PART,
  });
  const catalogApi = useApi(catalogApiRef);

  const { value } = useAsync(async () => {
    const result = await Promise.all(
      entities.flatMap(async ent => {
        const usedBy = await usedByEntitiesList(catalogApi, ent);
        const using = await usingEntitiesList(catalogApi, ent);

        return {
          usedBy,
          using,
        };
      }),
    );

    return result;
  }, [loading]);

  let usedBy: any = [];
  let using: any = [];

  value?.forEach(obj => {
    if (obj.usedBy.length > 0) {
      usedBy = usedBy.concat(obj.usedBy);
    }

    if (obj.using.length > 0) {
      using = using.concat(obj.using);
    }
  });

  return (
    <SystemRelationshipsWrapperCard
      usedByEntities={usedBy}
      usingEntities={using}
    />
  );
};
